import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';

export const Date = ({ value, ...props }) => {
  // make sure it is a moment instance
  if ( value && !moment.isMoment( value ))
    value = moment( value );

  return (
    <DatePicker 
      className='form-control' autoComplete='off'
      // display formats
      dateFormat='l' placeholderText={ moment().format( props.dateFormat || 'l' ) }
      // dropdowns
      showMonthDropdown showYearDropdown dropdownMode='select'
      // current date ( onChange comes in with the rest of the props )
      selected={ value }
      // override all props
      { ...props }
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/inputs/Date.jsx